/**
 * Scroll-reveal: elementen met [data-reveal] komen in beeld zodra ze de
 * viewport in scrollen. Begintoestand (verborgen) geldt alleen onder html.js,
 * zodat de pagina zonder JS gewoon zichtbaar is. Uit bij reduced-motion.
 */

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const targets = document.querySelectorAll('[data-reveal]');

if (reducedMotion) {
  for (const el of targets) el.classList.add('is-revealed');
} else {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  for (const el of targets) observer.observe(el);
}
